import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import * as profileActions from '@/redux/actions/profile';
import { createLoadingSelector } from '@/redux/selectors/core/loading';
import { getMobile } from '@/redux/selectors/mobile';
import TrainingSpeedQuizProvider from '@/contexts/TrainingSpeedQuizContext';
import AppDocumentTitle from '@/components/app/document-title';
import PageTrainingCourseProvider from '@/components/page/training/course/provider';
import UILoader from '@/components/ui/loader';
import StyledPageTraining, { StyledPageTrainingMain } from './styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: createLoadingSelector(['PROFILE_FETCH'])(state),
    isWebView: Boolean(getMobile(state))
  };
};

var mapDispatchToProps = {
  fetchProfile: profileActions.fetchProfile
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var PageTrainingCourse = /*#__PURE__*/lazy(function () {
  return import('@/components/page/training/course');
});
var PageTrainingMy = /*#__PURE__*/lazy(function () {
  return import('@/components/page/training/my');
});

var PageTraining = function PageTraining(_ref) {
  var isWebView = _ref.isWebView;

  var _useRouteMatch = useRouteMatch(),
      url = _useRouteMatch.url;

  return /*#__PURE__*/_jsxs(TrainingSpeedQuizProvider, {
    children: [/*#__PURE__*/_jsx(AppDocumentTitle, {
      descriptors: ['titleTraining']
    }), /*#__PURE__*/_jsx(StyledPageTraining, {
      "data-testid": "page-training",
      isWebView: isWebView,
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(UILoader, {}),
        children: /*#__PURE__*/_jsxs(PageTrainingCourseProvider, {
          children: [/*#__PURE__*/_jsx(StyledPageTrainingMain, {
            children: /*#__PURE__*/_jsxs(Switch, {
              children: [/*#__PURE__*/_jsx(Route, {
                path: "".concat(url, "/my"),
                children: /*#__PURE__*/_jsx(PageTrainingMy, {})
              }), /*#__PURE__*/_jsx(Redirect, {
                exact: true,
                from: url,
                to: "".concat(url, "/my")
              })]
            })
          }), /*#__PURE__*/_jsx(Switch, {
            children: /*#__PURE__*/_jsx(Route, {
              exact: true,
              path: ["".concat(url, "/favorites/:kind?"), "".concat(url, "/leaderboard"), "".concat(url, "/my/section/:identifier"), "".concat(url, "/tag/:id")]
            })
          })]
        })
      })
    })]
  });
};

export default connector(PageTraining);